import { useState } from 'react';
import { createPortal } from 'react-dom';
import { ClickAwayListener } from '@material-ui/core';
import PropTypes from 'prop-types';

import { DDUpgradePanel } from 'src/components/DDUpgradePanel';

import { useSetupFloating } from './useSetupFloating';
import { useStyles } from './useStyles';

export const LockedScorePopper = ({ referenceElement, placement, onUpgrade, onClose }) => {
  const styles = useStyles();

  const [popperElement, setPopperElement] = useState(null);
  const { floatingStyles } = useSetupFloating({
    popperElement,
    referenceElement,
    placement,
  });

  if (!referenceElement) {
    return null;
  }

  return createPortal(
    <ClickAwayListener onClickAway={onClose}>
      <div
        className={styles.root}
        ref={setPopperElement}
        style={floatingStyles}
      >
        <DDUpgradePanel
          onUpgrade={onUpgrade}
          onClose={onClose}
        />
      </div>
    </ClickAwayListener>,
    document.body
  );
};

LockedScorePopper.propTypes = {
  referenceElement: PropTypes.instanceOf(Element),
  placement: PropTypes.string,
  onUpgrade: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
LockedScorePopper.defaultProps = {
  referenceElement: null,
  placement: 'bottom-end',
};
